import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const UserCareManagerIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 36 36", width: sizePx, height: sizePx, style: styles, ...rest },
        React.createElement("g", { fill: "none", fillRule: "evenodd", strokeLinejoin: "round", strokeLinecap: "round", strokeWidth: "2", stroke: color },
            React.createElement("path", { d: "M7.2036 24.4755C3.7971 26.8515 1.7406 30.7503 1.0251 33.1695H28.1817" }),
            React.createElement("path", { d: "M17.8992 23.13C13.0446 23.13 9.1107 18.729 9.1107 13.2975C9.1107 7.866 13.0437 3.4641 17.8992 3.4641C22.7538 3.4641 26.6877 7.866 26.6877 13.2975C26.6877 14.7635 26 16 26 16" }),
            React.createElement("path", { d: "M23.6667 16H29.3333V21.6667H35V27.3333H29.3333V33H23.6667V27.3333H18V21.6667H23.6667V16Z" }))));
};
export default UserCareManagerIcon;
//# sourceMappingURL=index.js.map